module.exports = __webpack_public_path__ + "static/media/orange.663b95cb.jpg";